// SPDX-License-Identifier: AGPL-3.0-or-later

import {readStoredSessionUserId} from '@app/features/platform/state/auth_session/AuthSessionStorage';
import {makePersistent} from '@app/features/platform/utils/MobXPersistence';
import {makeAutoObservable} from 'mobx';

export type CoretTtsVoicePreset = 'natural' | 'feminine' | 'masculine';

class CoretTtsSettingsStore {
	autoSendInVoiceCall = false;
	voicePreset: CoretTtsVoicePreset = 'natural';

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
		const userId = readStoredSessionUserId(typeof window !== 'undefined' ? window.localStorage : {getItem: () => null});
		const storageKey = userId ? `CoretTtsSettings:${userId}` : 'CoretTtsSettings';
		void makePersistent(this, storageKey, ['autoSendInVoiceCall', 'voicePreset'], {
			syncAcrossTabs: true,
		});
	}

	setAutoSendInVoiceCall(value: boolean): void {
		this.autoSendInVoiceCall = value;
	}

	setVoicePreset(value: CoretTtsVoicePreset): void {
		this.voicePreset = value;
	}
}

export default new CoretTtsSettingsStore();
